module.exports = __webpack_public_path__ + "img/account_pay@2x.b042c90f.png";